import { Badge } from '@xiltrion/ui/badge';

interface AccountSecurity {
  authProvider: string;
  mfaEnabled: boolean;
  lastLoginAt: string | null;
}

/**
 * Columna «Ingreso» de Personas y de los miembros de una entidad: cómo entra la persona arriba y su último
 * ingreso abajo (`render` y `secundario` de la columna; `valor` sigue siendo `lastLoginAt` para ordenar).
 */
export const signInMethod = (account: AccountSecurity) => (account.authProvider === 'federated' ? 'Institucional' : 'Contraseña');
export const lastSignIn = (account: AccountSecurity) => (account.lastLoginAt ? `Último: ${new Date(account.lastLoginAt).toLocaleDateString('es-CO')}` : 'Nunca ha entrado');

/** Verificación en dos pasos; con ingreso institucional la pide (o no) el proveedor de su organización. */
export const mfaLabel = (account: AccountSecurity) => (account.mfaEnabled ? 'Activa' : account.authProvider === 'federated' ? 'De su organización' : 'Sin activar');

export function MfaBadge({ account }: { account: AccountSecurity }) {
  return <Badge variant={account.mfaEnabled ? 'success-light' : account.authProvider === 'federated' ? 'secondary' : 'warning-light'}>{mfaLabel(account)}</Badge>;
}
